





























































































































import { CampaignReportData } from "@/models/CampaignReport";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SitesSelector from "@/components/SitesSelector.vue";
import Site from "@/models/site";
import Campaign, { LineItem } from "@/models/campaign";

@Component({ components: { SitesSelector } })
export default class CampaignReportSummary extends Vue {
  @Prop() sites!: Site[];
  @Prop() data!: CampaignReportData;
  @Prop() loading!: boolean;

  site: string | null = null;
  lineItems: LineItem[] = [];
  filteredStats = {
    totalClicks: 0,
    totalPrints: 0,
    ctr: 0,
    avgPrintsPerMonth: 0,
    avgClicksPerMonth: 0,
    avgCtrPerMonth: 0,
  };

  get validSites(): Site[] {
    const sites: Site[] = [];
    this.sites.forEach((s) => {
      const valid = this.lineItems.find((l) => l.siteId === s.id);

      if (valid) {
        const exists = sites.find((e) => e.id === s.id);
        if (!exists) sites.push(s);
      }
    });
    return sites;
  }

  created(): void {
    this.lineItems = (this.data.campaign as Campaign).lineItems;
  }

  @Watch("site")
  setFilteredData(): void {
    if (this.site) {
      this.filteredStats = {
        totalClicks: 0,
        totalPrints: 0,
        ctr: 0,
        avgClicksPerMonth: 0,
        avgPrintsPerMonth: 0,
        avgCtrPerMonth: 0,
      };

      const lineItems: LineItem[] = [];
      this.lineItems.forEach((l) => {
        l.siteId === this.site ? lineItems.push(l) : null;
      });

      this.data.data.forEach((d) => {
        const validLineItem = lineItems.find((l) => l.id === d.lineItemId);
        if (validLineItem) {
          this.filteredStats.totalClicks += d.clicks;
          this.filteredStats.totalPrints += d.prints;
          // this.filteredStats.ctr += d.ctr;
        }
      });

      if (this.data.meta.nObs > 0) {
        this.filteredStats.avgClicksPerMonth = Math.floor(
          this.filteredStats.totalClicks / this.data.meta.nObs
        );
        this.filteredStats.avgPrintsPerMonth = Math.floor(
          this.filteredStats.totalPrints / this.data.meta.nObs
        );
        this.filteredStats.avgCtrPerMonth =
          this.filteredStats.totalClicks /
          this.filteredStats.totalPrints /
          this.data.meta.nObs;
      }
    }
  }

  @Watch("loading")
  cleanSiteSelection(): void {
    this.loading ? (this.site = null) : null;
  }

  getTotalClicks(): string {
    if (this.site !== "") {
      return "";
    } else {
      return this.data.summary.totalClicks.toLocaleString();
    }
  }

  setSite(site: string): void {
    this.site = site;
  }
}
